import { FilterBtnFragment } from '@graphqlTypes/sitecore';
import { useGlobalStore } from '@src/hooks/use-global-store';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';

interface Props {
    filterButtonsList: FilterBtnFragment[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectedFilter: FilterBtnFragment | 'all' | any;
    isSharePage?: boolean;
    filterButtonClk: (i: FilterBtnFragment | 'all') => void;
}

const FilterSectionListTabs = (props: Props) => {
    const { filterButtonsList, filterButtonClk, selectedFilter, isSharePage = false } = props;
    const containerRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    const globalStore = useGlobalStore();
    const global = globalStore.baseStore;

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollLeft = global.indexSLTagScroll ?? 0;
        }
    }, [global.indexSLTagScroll]);

    return (
        <div
            ref={containerRef}
            className='flex space-x-2 overflow-x-auto last:pr-7 pb-3 hide-scrollbar'
        >
            <button
                className={cn(
                    'rounded-full cursor-default text-[16px] py-[2px] px-3 font-medium border border-[#022169] text-[#022169] whitespace-nowrap',
                    { 'bg-[#022169] !text-white': selectedFilter === 'all' }
                )}
                onClick={() => {
                    if (isSharePage) {
                        return;
                    }
                    nonPageTracker({
                        eventID: TrackingEvent.ArticleListingFilter,
                        eventValue: t('all'),
                    });

                    global.indexSLTagScroll = 0;
                    filterButtonClk('all');
                }}
            >
                {t('all')}
            </button>

            {filterButtonsList.map((i, index) => {
                const isActive = selectedFilter !== 'all' && selectedFilter.id === i.id;
                return (
                    <button
                        key={index}
                        className={cn(
                            'rounded-full cursor-default text-[#022169] text-[16px] py-[2px] px-3 font-medium border border-[#022169] whitespace-nowrap',
                            { 'bg-[#022169] !text-white': isActive }
                        )}
                        onClick={() => {
                            if (isSharePage) {
                                return;
                            }
                            const next =
                                selectedFilter !== 'all' && selectedFilter.id === i.id ? 'all' : i;

                            if (next !== 'all' && next.id !== selectedFilter?.id) {
                                nonPageTracker({
                                    eventID: TrackingEvent.ArticleListingFilter,
                                    eventValue: i.buttonName?.value ?? '',
                                });
                            }

                            if (next === 'all') {
                                global.indexSLTagScroll = 0;
                                if (containerRef.current) {
                                    containerRef.current.scrollLeft = 0;
                                }
                            } else {
                                global.indexSLTagScroll = containerRef.current?.scrollLeft ?? 0;
                            }

                            filterButtonClk(next);
                        }}
                    >
                        {i.buttonName?.value ?? ''}
                    </button>
                );
            })}
        </div>
    );
};

export default observer(FilterSectionListTabs);
